module.exports = __webpack_public_path__ + "img/loader.3ed1cd5f.gif";